import { CrudList } from '../shared/CrudPage';
import { supplierService } from '@kss/api';
import type { Supplier, SupplierCreate, SupplierFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';

export default function AllSuppliers() {
  return (
    <CrudList<Supplier, SupplierCreate, SupplierFilter>
      title="Suppliers / Vendors"
      newLabel="New supplier"
      service={supplierService}
      idKey="supplierId"
      labelKey="name"
      basePath="/panel/suppliers"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 120 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'category', title: 'Category', width: 130, render: (r) => r.category ?? '—' },
        { accessor: 'phone', title: 'Phone', width: 140, render: (r) => r.phone || '—' },
        { accessor: 'gstin', title: 'GSTIN', width: 160, render: (r) => r.gstin || '—' },
        {
          accessor: 'overallScore',
          title: 'Score',
          width: 90,
          render: (r) =>
            r.overallScore != null ? (
              <span className="font-mono text-xs">{r.overallScore.toFixed(1)}</span>
            ) : '—',
        },
        {
          accessor: 'isBlacklisted',
          title: 'Status',
          width: 110,
          render: (r) =>
            r.isBlacklisted ? (
              <span className="inline-flex rounded bg-danger/10 px-2 py-0.5 text-xs font-medium text-danger">Blacklisted</span>
            ) : (
              <StatusBadge status={r.isActive ? 'active' : 'inactive'} />
            ),
        },
      ]}
    />
  );
}
